/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EvaluationParameterDto } from './EvaluationParameterDto';
import {
    EvaluationParameterDtoFromJSON,
    EvaluationParameterDtoFromJSONTyped,
    EvaluationParameterDtoToJSON,
} from './EvaluationParameterDto';
import type { EvaluationScopeCategory } from './EvaluationScopeCategory';
import {
    EvaluationScopeCategoryFromJSON,
    EvaluationScopeCategoryFromJSONTyped,
    EvaluationScopeCategoryToJSON,
} from './EvaluationScopeCategory';

/**
 * 
 * @export
 * @interface EvaluationParameterScopeDto
 */
export interface EvaluationParameterScopeDto {
    /**
     * 
     * @type {string}
     * @memberof EvaluationParameterScopeDto
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof EvaluationParameterScopeDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {EvaluationScopeCategory}
     * @memberof EvaluationParameterScopeDto
     */
    evaluationScopeCategory?: EvaluationScopeCategory;
    /**
     * 
     * @type {Array<EvaluationParameterDto>}
     * @memberof EvaluationParameterScopeDto
     */
    evaluationParameters?: Array<EvaluationParameterDto> | null;
    /**
     * 
     * @type {string}
     * @memberof EvaluationParameterScopeDto
     */
    $type?: EvaluationParameterScopeDtoTypeEnum;
}


/**
 * @export
 */
export const EvaluationParameterScopeDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoEvaluationParametersEvaluationParameterScopeDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.EvaluationParameterScopeDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type EvaluationParameterScopeDtoTypeEnum = typeof EvaluationParameterScopeDtoTypeEnum[keyof typeof EvaluationParameterScopeDtoTypeEnum];


/**
 * Check if a given object implements the EvaluationParameterScopeDto interface.
 */
export function instanceOfEvaluationParameterScopeDto(value?: unknown): value is EvaluationParameterScopeDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(EvaluationParameterScopeDtoTypeEnum)[0];
}

export function EvaluationParameterScopeDtoFromJSON(json: any): EvaluationParameterScopeDto {
    return EvaluationParameterScopeDtoFromJSONTyped(json, false);
}

export function EvaluationParameterScopeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationParameterScopeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        'evaluationScopeCategory': !exists(json, 'evaluationScopeCategory') ? undefined : EvaluationScopeCategoryFromJSON(json['evaluationScopeCategory']),
        'evaluationParameters': !exists(json, 'evaluationParameters') ? undefined : (json['evaluationParameters'] === null ? null : (json['evaluationParameters'] as Array<any>).map(EvaluationParameterDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function EvaluationParameterScopeDtoToJSON(value?: EvaluationParameterScopeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'isEnabled': value.isEnabled,
        'evaluationScopeCategory': EvaluationScopeCategoryToJSON(value.evaluationScopeCategory),
        'evaluationParameters': value.evaluationParameters === undefined ? undefined : (value.evaluationParameters === null ? null : (value.evaluationParameters as Array<any>).map(EvaluationParameterDtoToJSON)),
        '$type': value.$type,
    });
}

